import { Modal } from "./_bootstrapModalExtensions";
import { Interfaces } from "./_interfaces";

// Clicking the delete button on a single ticket can have multiple consequences
// 3 different things can happen, based on the environment and selection states
// - If nothing is selected (no grid or no selection available), then simply remove the tag from the document)
// - If rows are selected AND the user clicked in a selected row, then remove the tag from every selected document
// - If rows are selected BUT a NON SELECTED row is clicked, ONLY remove it from the selected document
export function DeleteTagFromDocumentClicked(docId, tagId, elem, gridName: string) {
    event.preventDefault();
    event.stopPropagation();

    if (gridName) {
        let grid = window[gridName] as MVCxClientGridView;

        let selectedKeys = grid.GetSelectedKeysOnPage();

        if (selectedKeys.length > 0) {

            var docIds = [];

            var isClickedTagSelected = false;

            for (var i in selectedKeys) {
                var keyParts = selectedKeys[i].split('|');
                var rowDocId = keyParts[0];

                docIds.push(rowDocId);

                // Does the "selected items list" contains the item we clicked?
                if (parseInt(rowDocId) === docId) {
                    isClickedTagSelected = true;
                }
            }

            if (isClickedTagSelected) {
                // Remove the tag from every selected document
                removeTagFromDocuments(docIds, tagId, function () {
                    // The grid could contain non visible rows (which ar eselected), so refresh the grid to clear up confusion (and really, this is the only clean way to show an up-to-data state)
                    grid.Refresh();
                });
            }
            else {
                // Non-selected item clicked, only remove from the clicked doc
                removeTagFromDocument([docIds], tagId, elem);
            }

        } else {
            // Nothing selected, only remove the tag from the current document
            removeTagFromDocument([docId], tagId, elem);
        }
    } else {
        // No grid, only remove from current element
        removeTagFromDocument([docId], tagId, elem);
    }

    return false;
}

function removeTagFromDocument(docIds, tagId, elem) {

    var $elem = $(elem);
    let delConfirmed = Modal.showConfirmationWindow("Biztosan törli a címkét a dokumentumról?");

    if (delConfirmed) {
        removeTagFromDocuments(
            docIds,
            tagId,
            function () {
                $elem.parent().remove();
            });
    }
}

function removeTagFromDocuments(docIds, tagId, onSuccess) {
    $.post({
        url: window.ETDR_RD.appConfig["UrlAction.DeleteLinkDocumentTag"],
        data: {
            docIds: docIds,
            tagId: tagId
        },
        success: function (data) {
            if (data.success) {
                if ($.isFunction(onSuccess)) {
                    onSuccess();
                }
            } else {
                Modal.showAlertWindow(data.alert, "Hiba");
            }
        },
        dataType: "json",
        traditional: true
    });
}

// dokumentumok szűrése a kiválasztott cimkékre
function FilterDocumentsByTags(gridName: string) {
    let grid = window[gridName] as MVCxClientGridView;
    let checkedElements = $('#AddTagToDocumentForm .tag-list__element--filteredby');

    if (checkedElements.length > 0) {

        var paramsToSend = [];

        checkedElements.each(function (i, tag) {

            paramsToSend.push($(tag).data('tagid'));
        });

        grid.PerformCallback({
            tagFilter: paramsToSend.join()
        });
    }
    else {
        grid.Refresh()
    }
}

export function ReselectRowsForDocumentAttachmentOnRefresh(grid: Interfaces.MVCxClientGridViewWithSelectedKeys, eventArgs) {
    if (grid.cpSelectedKeys) {
        if (eventArgs.command === 'REFRESH') {
            grid.cpUnderRefresh = true;

            grid.SelectRowsByKey(grid.cpSelectedKeys, true);
        }
    }
}

// új címke hozzáadása felhasználó saját címkekészletéhez
function AddNewTag() {
    let newTagName: string = $("#newTagName").val() as string;

    if (!newTagName) {
        return false;
    }

    newTagName = newTagName.trim();

    if (newTagName.length === 0) {
        return false;
    }

    var exists = $('.tag-list__element').filter(function (i, tag) {
        return $(tag).text() === newTagName;
    });

    if (exists.length) {
        Modal.showAlertWindow('Már van ilyen nevű címke', 'Figyelem!');
        return false;
    }

    if (newTagName !== '') {
        $.post(
            window.ETDR_RD.appConfig["UrlAction.AddUserTag"],
            {
                tagName: newTagName
            },
            function (data) {
                if (data.success) {
                    let $deleteIcon = $('<span class="icon-ico-close pl-1"></span>');
                    let $newTag = $('<span class="tag-list__element"></span>')
                        .attr("data-tagid", data.tagId)
                        .attr("ondragstart", "drag(event)")
                        .attr("id", data.tagId)
                        .text(newTagName)
                        .append($deleteIcon);
                    $('#other-tags').append($newTag);

                    $("#newTagName").val('');

                    tagHelperTextReset();
                }
            });
    }

    return false;
}

function tagHelperTextReset() {
    $('.tag-helptext').toggleClass('d-none', !!$('#AddTagToDocumentForm .tag-list__element').length);
}

// kijelölt címkék törlése felhasználó saját címkekészletéből
// If grid is specified and the AJAX call succeeds, refresh the grid content
function DeleteTag($tag, grid) {

    var tagIds = [$tag.data('tagid')];

    if (!Modal.showConfirmationWindow('Valóban törölni kívánja ezt a címkét a rendszerből?')) {
        return false;
    }

    if (grid) {
        grid.SetEnabled(false);
    }

    return $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.DeleteUserTag"],
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(tagIds),
        success: function (data) {
            $tag.remove();
            grid.Refresh();
            tagHelperTextReset();
        },
        complete: function () {
            if (grid) {
                grid.SetEnabled(true);
            }
        }
    });
}

export function InitializeTagging(gridName: string) {

    var grid = window[gridName] as MVCxClientGridView;

    $('.tag-list__new-tag').on('submit', AddNewTag);

    tagHelperTextReset();

    $('body').on('click', '#OpenTagDialogButton', function () {
        if (!$('#AddTagToDocumentForm').is(':visible')) {
            $('#AddTagToDocumentForm').show();
        } else {
            $('#AddTagToDocumentForm').hide();
        }
    });

    // set filter by tag when click
    $("body").on('click', '.tag-list__element', function () {
        var cn = 'tag-list__element--filteredby';
        var $list = $(this).closest('.tag-elements');

        if ($(this).hasClass(cn)) {
            $(this).removeClass(cn);

            var exists = $list.find('.' + cn);

            if (exists.length === 0) {
                $list.removeClass('tag-elements--filtered');
            }
        }
        else {
            $list.addClass('tag-elements--filtered');
            $(this).addClass(cn);
        }

        FilterDocumentsByTags(gridName);
    });

    // disabled tag filtering when click tag delete sign 
    $("body").on('click', '.tag-list__element > span.fa', function (e) {
        e.stopPropagation();
    });

    // ToDo: Praktikusabb lenne, hogyha nem a címkén lévő ikon classától függene a működés.
    $('.tag-elements').on('click', '.tag-list__element .custom-close', function (e) {
        var $tag = $(this).closest('.tag-list__element');
        var ret = DeleteTag($tag, grid);

        return ret;
    });

    AddHandlerToList();
    $('body').on('click', '*', AddHandlerToList);

    var addedHandlerToDocs = false;
    function AddHandlerToList() {
        try {
            if (grid && !addedHandlerToDocs) {
                addedHandlerToDocs = true;
                grid.EndCallback.AddHandler(function () {
                    var selectedRows = grid.GetSelectedKeysOnPage();
                    if (selectedRows.length !== 1) $('.gridaction.download:visible').addClass('disabled');
                    if (selectedRows.length === 0) $('.gridaction.del:visible').addClass('disabled');
                });
            }
        } catch (e) {
            console.log(e);
        }
    }
}

function allowDrop(ev) {
    ev.preventDefault();
}

export function drag(ev) {
    ev.dataTransfer.setData("text", ev.target.id);
}

function drop(ev, gridName: string) {
    ev.preventDefault();

    var tagId = ev.dataTransfer.getData("text");

    let grid = window[gridName] as MVCxClientGridView;

    // multiple rows selected, apply the tag to all rows
    let selectedRowsCount = grid.GetSelectedRowCount();
    if (selectedRowsCount >= 2) {
        let rowKeys = grid.GetSelectedKeysOnPage();
        for (let i = 0; i < selectedRowsCount; i++) {
            let rowId = rowKeys[i].split('|')[0];

            let $item = AddTagCloneToRow(tagId, rowId);
            AddDeleteIcon($item, rowId, tagId, gridName);

            addTagToDocument($item, rowId);
        }
    } else {
        let visibleIndex = $(ev.target).closest("tr").attr("id").split("DXDataRow")[1];
        let rowHash = grid.GetRowKey(Number.parseInt(visibleIndex));
        let rowId = rowHash.split("|")[0];
        let $item = AddTagCloneToRow(tagId, rowId);

        AddDeleteIcon($item, rowId, tagId, gridName);

        addTagToDocument($item, rowId);
    }
}

function AddTagCloneToRow(tagId, rowId) {
    let newId = tagId + "-" + Date.now() + "-copiedTag";
    let nodeCopy = document.getElementById(tagId).cloneNode(true) as Element;
    nodeCopy.id = newId; /* We cannot use the same ID */
    $("#docTags-" + rowId).append(nodeCopy);

    let nodeCopyRo = document.getElementById(tagId).cloneNode(true) as Element;
    nodeCopyRo.id = newId + 'ro'; /* We cannot use the same ID */
    $("#docTags-readonly-" + rowId).append(nodeCopyRo);

    return $("#" + newId);
}

function AddDeleteIcon($item, rowKey, tagId, gridName) {
    let onclickFunction = "ETDR.DeleteTagFromDocumentClicked(" + rowKey + ", " + tagId + ", this, '" + gridName + "')";

    if ($item.children("span.fa").length > 0) {
        $item.children("span.fa").attr('onclick', onclickFunction);
    }
    else {
        let deleteIcon = $('<span class="icon-ico-close"></span>');
        deleteIcon.attr('onclick', onclickFunction);
        $item.append(deleteIcon);
    }
}

export function addTagToDocument($newTag, rowId) {
    var $docTag = $('#docTags-' + rowId);

    var $existingTag = $docTag.find('.tag-item')
        .filter(function (i, tag) {
            return $(tag).data().tagid == $newTag.data().tagid;
        });

    if (!$existingTag.length) {
        // Then ask the server to save this change
        $.ajax({
            url: window.ETDR_RD.appConfig["UrlAction.UploadDocTagList"],
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify([[rowId, $newTag.data().tagid]]),
            success: function (data, textStatus, jqXHR) {
                // The server side supports multiple documents and tags, but the drag'n'drop function does not
                // Good for us, because no additional error checks are needed
                if (!data.success) {
                    $newTag.remove();
                }
            }
        });
    }
    else {
        $newTag.remove();
    }
}

function addDragAndDropEventListeners() {
    $("#uploadedDocs .droppable").off("drop").on("drop", function (event) { drop(event.originalEvent, "uploadedDocs"); });
    $("#gvRowSelection .droppable").off("drop").on("drop", function (event) { drop(event.originalEvent, "gvRowSelection"); });

    $(".droppable").off("dragover").on("dragover", function (event) { allowDrop(event.originalEvent); });
}

$(function () {
    addDragAndDropEventListeners();
});

$(document).ajaxComplete(function () {
    addDragAndDropEventListeners();
});
